import { createFileRoute, notFound } from "@tanstack/react-router";
import {
  LAWFIRM_QA,
  LAWFIRM_QA_BY_SLUG,
  LAWFIRM_REVIEWED_ISO,
  LAWFIRM_REVIEWED_TH,
} from "@/data/lawfirm/questions";
import { ClusterQaDetail, clusterQaDetailHead, type ClusterQaMeta } from "@/lib/qa/cluster-pages";

const M: ClusterQaMeta = {
  base: "/practice",
  label: "สำนักงานทนายความและสำนักงานกฎหมาย",
  reviewedIso: LAWFIRM_REVIEWED_ISO,
  reviewedTh: LAWFIRM_REVIEWED_TH,
};

export const Route = createFileRoute("/practice/q/$slug")({
  loader: ({ params }) => {
    if (!LAWFIRM_QA_BY_SLUG[params.slug]) throw notFound();
    return { slug: params.slug };
  },
  head: ({ loaderData }) => clusterQaDetailHead(M, loaderData ? LAWFIRM_QA_BY_SLUG[loaderData.slug] : undefined),
  component: Page,
});

function Page() {
  const { slug } = Route.useLoaderData();
  const qa = LAWFIRM_QA_BY_SLUG[slug];
  if (!qa) throw notFound();
  return <ClusterQaDetail m={M} qa={qa} all={LAWFIRM_QA} />;
}
